<template>
  <div class="folder-item-main">
    <div
      class="folder-item"
      @click="toFolder"
      :class="{ active: folderId === item.id }"
      :style="{ 'padding-left': (40 + level * 20) + 'px' }"
    >
      <i
        class="icon more"
        v-show="item.children"
        @click.stop="isOpen = !isOpen"
        :style="{ left: (15 + level * 20) + 'px' }"
        :class="{ open: isOpen }"
      ></i>
      <i class="icon folder" :class="{ 'folder-open': isOpen }"></i>
      <p>{{ item.name }}</p>
    </div>
    <div class="folder-child" v-show="isOpen">
      <folder-tree-item
        @openFolder="changeFolderStatus"
        @toFolder="childToFolder"
        :level="level + 1"
        v-for="(item, index) in item.children"
        :key="index"
        :item="item"
      ></folder-tree-item>
    </div>
  </div>
</template>
<script>
export default {
  name: "folder-tree-item",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  watch: {
    folderId(val) {
      this.isOpen =
        val === this.item.id ||
        (this.item.children && this.calcChildrenOpen(this.item.children));
    }
  },
  computed: {
    folderId: {
      get() {
        return this.$store.state.folderId;
      },
      set(value) {
        this.$store.commit("changeFolderId", value);
      }
    }
  },
  methods: {
    calcChildrenOpen(data) {
      return (
        data.filter(it => {
          return (
            it.id === this.folderId ||
            (it.children && this.calcChildrenOpen(it.children))
          );
        }).length > 0
      );
    },
    changeFolderStatus() {
      this.isOpen = true;
    },
    childToFolder(payload) {
      if (payload.parentNode) {
        payload.parentNode.push(this.item);
      } else {
        payload.parentNode = [this.item];
      }
      this.$emit("toFolder", payload);
    },
    toFolder() {
      this.folderId = this.item.id;
      this.$emit("toFolder", { item: this.item });
    }
  }
};
</script>
<style lang="scss" scoped>
.folder-item-main {
  .folder-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 30px;
    padding: 0 20px 0 40px;
    cursor: pointer;
    position: relative;

    &:hover,
    &.active {
      background: #eaeaea;
    }

    i.more {
      width: 20px;
      height: 20px;
      background: url(../assets/images/folder-more-icon.png) no-repeat;
      transition: all 0.5s;
      transform: rotate(-90deg);
      margin-right: 3px;
      position: absolute;
      left: 15px;
      top: 5px;
      &.open {
        transform: rotate(0deg);
      }
    }

    i.folder {
      width: 20px;
      height: 20px;
      background: url(../assets/images/folder-icon.png) no-repeat;
      margin-right: 10px;

      &.folder-open {
        background: url(../assets/images/folder-icon-open.png) no-repeat;
      }
    }
  }
}
</style>